import { render, staticRenderFns } from "./study.vue?vue&type=template&id=282dd50e&scoped=true"
import script from "./study.vue?vue&type=script&lang=js"
export * from "./study.vue?vue&type=script&lang=js"
import style0 from "./study.vue?vue&type=style&index=0&id=282dd50e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282dd50e",
  null
  
)

export default component.exports